module.exports = __webpack_public_path__ + "assets/img/daohang2.e4ec6ddd.svg";